
function TableVM () {
  var self = this;
  self.paginator = ko.observable();
  self.request_pool = new Kadenze.AjaxRequestPool();
  self.placeholder = {
    visible: ko.observable(false),
    type: ko.observable('no_results') //or 'loading'
  };

  if ($.support.pjax) {
    $(document).on('pjax:click page:before-unload', function () {
      self.request_pool.abortAll();
    });
  }
}

TableVM.prototype = {
  filterResultsText: function () {
    if (typeof this.student_ids != 'undefined') {
      return 'Now Viewing: {count} Student{plural}'.supplant({count: this.student_ids().length, plural: this.student_ids().length > 0 ? 's' : ''});
    } else if (typeof this.coursework_ids != 'undefined') {
      return 'Now Viewing: {count} Coursework'.supplant({count: this.coursework_ids().length});
    }
  },
  removeFilter: function(item, event) {
    this.params.filters.remove(item);
  },
  showPlaceholder: function (type) {
    this.placeholder.type(type);
    this.placeholder.visible(true);
  },
  hidePlaceholder: function () {
    this.placeholder.visible(false);
  },
  filterChanged: function () {
    this.$el.click(); //Hack to close selectpicker & menus
    this.request_pool.abortAll();
    this.showPlaceholder('loading');
    if (this.mp)
      this.mp.end();
    this.getSheet(null, ko.mapping.toJS(this.params));
  },
  pageChanged: function (url) {
    var self = this;
    Kadenze.UIUtil.showLoadingIndicator(this.$el);
    this.request_pool.abortAll();
    if (this.mp)
      this.mp.end();
    this.getSheet(url).always(function () {
      Kadenze.UIUtil.hideLoadingIndicator(self.$el);
    });
  },
  updateMenuPosition: function($filterMenu) {
    var $btn = $('.dropdown-toggle', $filterMenu);
    var $menu = $('.dropdown-menu', $filterMenu);
    var $doc = $(document);
    var self = this;

    if ($filterMenu.hasClass('open')) {
      setTimeout(function() {
        var offset = $btn.offset();
        var vp = {
          width : window.innerWidth,
          height : window.innerHeight
        };
        var dSize = {
          width: $menu.outerWidth(),
          height: $menu.outerHeight()
        };
        var pos = {
          top: offset.top - $doc.scrollTop() + 18,
          left: offset.left - $doc.scrollLeft()
        };

        var leftOffset = (pos.left + dSize.width >= vp.width ) ? (dSize.width - $btn.width()) : 0;
        var topOffset = (pos.top + dSize.height >= vp.height ) ? (dSize.height + $btn.height() ) : 0;

        var newTop = (pos.top - topOffset);
        var newLeft = (pos.left - leftOffset);

        $menu.css({'position':'fixed','top':newTop, 'left': newLeft });
        self.updateMenuPosition($filterMenu);
        console.log('updateMenuPosition', topOffset);
      }, 10);
    }
  },
  userInfoTooltipParams: function (user) {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        email: user.email(),
        username: user.slug(),
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'right',
      showDelay: .7
    };
  },
  courseworkInfoTooltipParams: function (coursework) {
    return {
      template: 'templates/tooltip-coursework',
      templateParams: {
        name: coursework.name(),
        family: coursework.family(),
        family_color: coursework.family_color(),
        due_date: coursework.adaptive() ? undefined : moment(coursework.due_date()).format(Kadenze.I18n.t('date.formats.js_default_time')),
        published_at: coursework.adaptive() ? moment(coursework.published_at()).format(Kadenze.I18n.t('date.formats.js_default_time')) : undefined,
        weight: coursework.weight.extend({numberToPercentage: 0})(),
        view_coursework_path: coursework.view_coursework_path()
      },
      position: 'top'
    };
  },
  createRingChart: function(element, value) {
    if (isNaN(parseInt(value)))
      return;
    var score = parseInt(value);
    var remaining = parseInt(((score > 100) ? score : 100) - score);
    var chart = new Chartist.Pie(element, {
      series: [score, remaining],
      labels: [1]
    }, {
      donut: true,
      showLabel: false
    });
    return chart;
  },
  ringChartLabel: function (rawVal) {
    return !isNaN(parseInt(rawVal)) ? ko.observable(rawVal).extend({numberToPercentage: 0})() : 'N/A';
  }
};

export default TableVM;
